// Types
import { DefaultTimeouts } from '../types/DefaultTimeouts';
/**
 * Calls the onDoubleClick callback when the returned function is called twice
 *
 * When using this function in a component, ensure it is wrapped in a useMemo to prevent
 * the retrieval of a new instance
 *
 * @example
 *  // Components - useMemo
 *  const handleDoubleClick = React.useMemo(() => getDoubleClickHandler(), []);
 * @param {number} [timeoutDuration=300] Double click delay
 * @returns {{ handleDoubleClick: (onDoubleClick: () => void) => void }} Runs the callback if this fn is called twice within the timeoutDuration
 */
export var getDoubleClickHandler = function (onDoubleClick, timeoutDuration) {
    if (timeoutDuration === void 0) { timeoutDuration = DefaultTimeouts.DoubleClick; }
    var timeoutRef = 0;
    return function (args) {
        clearTimeout(timeoutRef);
        if (timeoutRef !== 0) {
            timeoutRef = 0;
            onDoubleClick === null || onDoubleClick === void 0 ? void 0 : onDoubleClick.apply(void 0, args);
        }
        else {
            timeoutRef = window.setTimeout(function () {
                timeoutRef = 0;
            }, timeoutDuration);
        }
    };
};
//# sourceMappingURL=getDoubleClickHandler.js.map